import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueI18n from 'vue-i18n'
import VueMeta from 'vue-meta'
import VueScrollTo from 'vue-scrollto'

import '@/assets/scss/app.scss'

import App from '@/App.vue'

import router from '@/router'
import store from '@/store'
import utils from '@/utils'

import { ApiService } from '@/common/api.service'
import Sampling from '@/plugins/sampling'
import VueAnalytics from '@/plugins/vue-analytics'

import { ClickOutside } from '@/directives'

import filters from '@/filters'

Vue.config.productionTip = false
utils.cleanUpHeadTag()

// Preview mode
const preview = window.location.search.indexOf('preview') != -1
store.commit('settings/setPreview', preview)

Vue.use(VueAwesomeSwiper)
Vue.use(VueScrollTo)
Vue.use(VueI18n)
Vue.use(VueMeta)
Vue.use(Sampling, { enabled: !preview })
Vue.use(VueAnalytics, { enabled: !preview })

Vue.directive('click-outside', ClickOutside)
Vue.use(filters)

ApiService.init()

new Vue({
  i18n: new VueI18n({
    locale: 'da-DK',
    fallbackLocale: 'en-UK',
    messages: {
      'en-UK': require('./locales/en-UK.json'),
      'da-DK': require('./locales/da-DK.json'),
    },
  }),
  router,
  store,
  render: h => h(App),
}).$mount('#speedperform')
